<template>

    <div class="wizard-component radio-buttons with-checkboxes">

        <p class="subject">{{ title }}</p>

        <div v-for="(item, index) in options" :key="index">
            <label class="custom-radio">
                <input
                        type="radio"
                        :name="name"
                        :value="item.value"
                        v-model="picked"
                        @input="$emit('input', item.value)"
                />
                <span class="radio-circle"></span>
                {{ item.label }}
            </label>
        </div>

    </div>

</template>


<script>
    export default {
        props: {
            options: {
                type: Array,
                default: []
            },
            title: String,
            name: {
                type: String,
                required: true
            },
            value: {}
        },
        data() {
            return {
                picked: null

            }
        },
        mounted() {
            this.picked = this.value
        }
    }
</script>


<style></style>
